import { Card } from "reactstrap";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import moment from "moment";
import {
  calculatePercentage,
  roundToAnyDecimalPlaces,
} from "utilFunctions/helperFunctions/utilFunctions";
import { displayNumberWithDecimals } from "Pages/BranchHealth/BranchHealthTable";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import { capitalizeFirstCharaterOfString } from "utilFunctions/helperFunctions/utilFunctions";
import React, { useContext, useState, useEffect, useMemo } from "react";
import { ToastContextDispatch } from "Context/CommonContext";
import {
  BASE_URL,
  GET_TESTSYLLABUS_STATUS,
  GET_BATCH_TEST_DETAILS,
  DOWNLOAD_MEDPRO_URL,
} from "utilFunctions/Constants/urlConstants";
import FilterSliderComponent from "Components/FilterSliderComponent/FilterSliderComponent";
import useGlobalSearchContext from "Context/GlobalSearchContext";
import { returnRiskSegment } from "Pages/SyllabusCompliances/SyllabusComplianceBatchTable";
import { useNavigate, useParams } from "react-router-dom";
import TableLayoutAntd from "utilFunctions/shared/AntdSharedComponents/TableLayoutAntd";
import { Table, Space, Tag, Tooltip } from "antd";
import { CustomMyBatchCard } from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchStudentDetailTab";
import { Button } from "antd";
import { DownloadOutlined, UndoOutlined } from "@ant-design/icons";
import { putPostRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import putPostRequestInterface from "utilFunctions/Axios/putPostRequestInterface";
import { myBatchEmitter } from "Pages/MyBatches/EmitterBus";
import { EVALUATED_TEST_STATUS_COLORS } from "Pages/TestEvaluation/constants";
import { useMyBatchContext } from "Pages/MyBatches/MyBatch/Context/useMyBatchContext";
import InfoIcon from "Assets/Icons/InfoIcon";
const COLOR_TAG: any = {
  Initiated: "orange",
  Completed: "green",
  Retry: "blue",
  Failed: "red",
  Progressing: "yellow",
  Queued: "purple",
};
export const returnPlannedLecture = (val1: number, val2: number) => {
  return val1 + "/" + val2;
};
export const popBodyShowComponent: any = (popoverContent: any) => {
  return (
    <>
      <div className="d-flex gap-2">
        {popoverContent?.map((ele: any) =>
          returnRiskSegment(
            roundToAnyDecimalPlaces(
              Number(
                displayNumberWithDecimals(
                  calculatePercentage(ele.markedNodeCount, ele.totalNodeCount)
                )
              ),
              2
            ),
            ele?.subject &&
              capitalizeFirstCharaterOfString(ele?.subject) +
                " : " +
                roundToAnyDecimalPlaces(
                  Number(
                    displayNumberWithDecimals(
                      calculatePercentage(
                        ele.markedNodeCount,
                        ele.totalNodeCount
                      )
                    )
                  ),
                  2
                ) +
                " %",
            false
          )
        )}
      </div>
    </>
  );
};
const MyBatchTestsTab = ({
  testSyllabusStatus,
  setTestSyllabusStatus,
  testDetailsFilter,
  batchDetailById,
  testTypes,
  filterListing,
  setFilterState,
  batchDetailsData,
  batchDetail,
}: any) => {
  const { totalNumberOfStudents: TotalStudents = 0 } = batchDetail || {};
  const [showPastTest, setShowPastTest] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [testDetailsData, settestDetailsData] = useState<any>(null);
  const [testDetailsMasterData, setTestDetailsMasterData] = useState<any>(null);
  const [counts, setCounts] = useState<any>([]);
  const { myBatchTestsTabState, setMyBatchTestsTabState } = useMyBatchContext();
  const [selectedType, setSelectedType] = useState(
    myBatchTestsTabState?.selectedType || "PAST"
  );
  const [pagination, setPagination] = useState(
    myBatchTestsTabState?.pagination || {
      pageSize: 10,
      total: 0,
      pageSizeOptions: ["10", "50", "100"],
      showSizeChanger: true,
      current: 1,
    }
  );

  useEffect(() => {
    setMyBatchTestsTabState({
      selectedType,
      pagination,
    });
  }, [selectedType, pagination]);
  const ToastDispatch = useContext(ToastContextDispatch);
  const { globalSearchData, saveGlobalSearchData } = useGlobalSearchContext();
  const [filterheadingListing, setfilterheadingListing] = useState([
    {
      name: "Test Type",
      nickName: "testTypes",
      data: testTypes,
      singleSelect: true,
      filterSelectedData: [],
    },
  ]);
  const [testDataMap, setTestDataMap] = useState(new Map());
  const [loadingMap, setLoadingMap] = useState<Map<number, boolean>>(new Map());
  useEffect(() => {
    const newMap = new Map(testDataMap);
    (testDetailsData || []).forEach((ele: any) => {
      newMap.set(ele.id, {});
    });
    setTestDataMap(newMap);
  }, [testDetailsData]);
  console.log("batchDetailById", batchDetailById);
  useEffect(() => {
    setfilterheadingListing([
      {
        name: "Test Type",
        nickName: "testTypes",
        data: testTypes,
        singleSelect: true,
        filterSelectedData: [],
      },
    ]);
  }, [batchDetailById]);
  const { makeRequest: PostTestSyllabusStatus } = usePutPostAPI(
    (data: any) => {
      if (data["data"] && data["data"].length) {
        setTestSyllabusStatus(data["data"]);
      } else {
        setTestSyllabusStatus([]);
      }
    },
    (error) => {
      console.log(error);
    },
    "Post"
  );

  const PostDownloadMedPro = (url: string, data: any, testId: number) => {
    putPostRequest({
      url: url,
      success: (data: any) => {
        const response = data["data"]?.data || {};
        handlePostData(response, testId);
      },
      failure: (error: any) => {
        if (error && error["message"]) {
          ToastDispatch({
            isOpen: true,
            type: "Error",
            message: error.message,
          });
        }
      },
      body: data,
      method: "post",
    } as putPostRequestInterface);
  };
  const handlePostData = (response: any, testId: number) => {
    const { jobStatus, url } = response;
    if (jobStatus === "Completed") {
      if (url) {
        const downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.download = "medpro.zip";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } else {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No scoretool data found",
        });
      }
    }
    const newMap = new Map(testDataMap);
    newMap.set(testId, response);
    setTestDataMap(newMap);
  };
  // const returnBatchData = (id: number) => {
  //   return testSyllabusStatus.filter(
  //     (ele: any) => ele.testScheduleId === id
  //   )?.[0]?.testSyllabusStatusDataList;
  // };

  const { makeRequest: GetTestDetailsData, loading: tableloading } = useGetApi(
    (data) => {
      if (data && data["data"]) {
        const { counts = [], tests = [] } = data["data"] || {};
        const { totalCount = 0 } = data || {};
        console.log("data=====", counts, data["data"]);
        setCounts(counts);
        setPagination({
          ...pagination,
          total: totalCount,
        });
        setTestDetailsMasterData(tests);
        settestDetailsData(tests);
      } else {
        setTestDetailsMasterData([]);
        settestDetailsData([]);
      }
    },
    (error) => {
      console.log("batch data from API error");
      setTestDetailsMasterData([]);
      settestDetailsData([]);
      if (error && error["message"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  const handler = (value: string, myBatchFilter: any) => {
    console.log("toggle tab handler called", value, myBatchFilter);
    const showPastTest =
      myBatchFilter && myBatchFilter.uptestType == "Past Tests" ? true : false;
    setShowPastTest(showPastTest);
    const type = showPastTest ? "PAST" : "LIVE";
    setSelectedType(type);
    setPagination((prev: any) => ({ ...prev, current: 1 }));
  };
  useEffect(() => {
    myBatchEmitter.on("toggleTab", handler);
    return () => {
      myBatchEmitter.off("toggleTab", handler);
    };
  }, []);
  useEffect(() => {
    const offset = (pagination.current - 1) * pagination.pageSize;
    const limit = pagination.pageSize;
    const batchTestUrl = `${BASE_URL}${GET_BATCH_TEST_DETAILS}/v2?batchId=${id}&type=${selectedType}&offset=${offset}&limit=${limit}&academicSession=2025-2026`;
    GetTestDetailsData(batchTestUrl);
  }, [selectedType, pagination.current, pagination.pageSize]);

  const handleTableChange = (pagination: any) => {
    setPagination(pagination);
  };

  useEffect(() => {
    if (testDetailsMasterData) {
      if (
        testDetailsFilter &&
        testDetailsFilter != null &&
        testDetailsFilter != ""
      ) {
        const filteredList = testDetailsMasterData.filter(
          (obj: any) => obj["type"] == testDetailsFilter
        );
        settestDetailsData(filteredList);
      } else {
        const batchTestUrl = `${BASE_URL}syllabusCompliance/batchTests?batchId=${id}&showPastTest=${showPastTest}`;
        console.log("URL FOR BATCH DETAILS abcd", batchTestUrl);
        GetTestDetailsData(batchTestUrl);
      }
    }
  }, [testDetailsFilter]);

  const { screen }: any = useWindowSize();
  const renderingTime = (date: any) => {
    return <div className="d-flex">{moment(date).format("D MMM YY")}</div>;
  };
  // const routeToMyBatch = (item: any) => {
  //   navigate("/admin/mybatch/test/" + item.cmsTestId, {
  //     replace: false,
  //     state: {
  //       test: item,
  //       batchId: id,
  //       testSyllabusStatus,
  //       batchName: batchDetailsData?.batchName,
  //       batchDetail: batchDetailsData,
  //     },
  //   });
  // };
  const columns: any = useMemo(() => {
    return [
      {
        title: "Test Name",
        dataIndex: "testName",
        width: 150,
        fixed: "left",
        render: (_: any, item: any) => {
          return (
            <span
              className="filterSpan"
              style={{
                textAlign: "left",
              }}
              onClick={() => {
                window.sessionStorage.setItem(
                  "shouldPersistMyBatchTab",
                  "true"
                );
                navigate("/admin/test-evaluation/" + item.id, {
                  replace: false,
                  state: {
                    test: item,
                    batchId: id,
                    testSyllabusStatus,
                    batchName: batchDetailsData?.batchName,
                    batchDetail: batchDetail,
                    batchDetailsData: batchDetailsData,
                    batchDetailById,
                    action:
                      item?.testResultDate &&
                      moment(item.testResultDate).isBefore(moment())
                        ? "view"
                        : "evaluate",
                  },
                });
              }}
            >
              {item?.testName}
            </span>
          );
        },
      },
      {
        title: "Start Date-End Date",
        dataIndex: "startDate",
        width: 200,
        render: (_: any, item: any) => {
          const {
            mode,
            offlineStartDate,
            offlineEndDate,
            onlineStartDate,
            onlineEndDate,
          } = item || {};
          return (
            <>
              {mode === "Both" ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "6px",
                    minWidth: 0,
                  }}
                >
                  {/* Online row */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      flexWrap: "nowrap",
                    }}
                  >
                    <Tooltip
                      title={
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <span
                            style={{
                              width: 7,
                              height: 7,
                              borderRadius: "50%",
                              background: "#22c55e",
                              display: "inline-block",
                              flexShrink: 0,
                            }}
                          />
                          <span style={{ fontWeight: 600 }}>Online:</span>
                        </span>
                      }
                      color="#1f2937"
                      placement="top"
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "3px",
                          padding: "1px 7px",
                          borderRadius: "10px",
                          fontSize: "11px",
                          fontWeight: 600,
                          background:
                            "linear-gradient(135deg, #e6f9ee 0%, #d0f0e0 100%)",
                          color: "#1a8a4a",
                          border: "1px solid #a7d9b8",
                          letterSpacing: "0.3px",
                          whiteSpace: "nowrap",
                          flexShrink: 0,
                          minWidth: "54px",
                          justifyContent: "center",
                          cursor: "default",
                        }}
                      >
                        <span
                          style={{
                            width: 6,
                            height: 6,
                            borderRadius: "50%",
                            background: "#22c55e",
                            display: "inline-block",
                          }}
                        />
                        {moment(onlineStartDate).format("D MMM 'YY")}
                        <span style={{ color: "#9ca3af", margin: "0 3px" }}>
                          →
                        </span>
                        {moment(onlineEndDate).format("D MMM 'YY")}
                      </span>
                    </Tooltip>
                  </div>
                  {/* Offline row */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      flexWrap: "nowrap",
                    }}
                  >
                    <Tooltip
                      title={
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <span
                            style={{
                              width: 7,
                              height: 7,
                              borderRadius: "50%",
                              background: "#9ca3af",
                              display: "inline-block",
                              flexShrink: 0,
                            }}
                          />
                          <span style={{ fontWeight: 600 }}>Offline:</span>
                        </span>
                      }
                      color="#1f2937"
                      placement="top"
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "3px",
                          padding: "1px 7px",
                          borderRadius: "10px",
                          fontSize: "11px",
                          fontWeight: 600,
                          background:
                            "linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)",
                          color: "#4b5563",
                          border: "1px solid #d1d5db",
                          letterSpacing: "0.3px",
                          whiteSpace: "nowrap",
                          flexShrink: 0,
                          minWidth: "54px",
                          justifyContent: "center",
                          cursor: "default",
                        }}
                      >
                        <span
                          style={{
                            width: 6,
                            height: 6,
                            borderRadius: "50%",
                            background: "#6b7280",
                            display: "inline-block",
                          }}
                        />
                        {moment(offlineStartDate).format("D MMM 'YY")}
                        <span style={{ color: "#9ca3af", margin: "0 3px" }}>
                          →
                        </span>
                        {moment(offlineEndDate).format("D MMM 'YY")}
                      </span>
                    </Tooltip>
                  </div>
                </div>
              ) : (
                <div className="d-flex">
                  {renderingTime(
                    mode === "Online" ? onlineStartDate : offlineStartDate
                  )}{" "}
                  {"→"}
                  {renderingTime(
                    mode === "Online" ? onlineEndDate : offlineEndDate
                  )}{" "}
                </div>
              )}
            </>
          );
        },
      },
      {
        title: "Format | Mode",
        dataIndex: "format",
        width: 140,
        render: (_: any, item: any) => {
          return (
            <>
              {" "}
              {item?.format} | {item?.mode}
            </>
          );
        },
      },
      {
        title: "Evaluation Date",
        dataIndex: "evaluationDate",
        width: 130,
        render: (_: any, item: any) => {
          return (
            <>
              {" "}
              {item?.evaluationDate == null
                ? "-"
                : renderingTime(item?.evaluationDate)}
            </>
          );
        },
      },
      {
        title: "Result Date",
        dataIndex: "testResultDate",
        width: 110,
        render: (_: any, item: any) => {
          console.log("item?.testResultDate", item?.testResultDate);
          return <> {renderingTime(item?.testResultDate)}</>;
        },
      },
      {
        title: () => (
          <Tooltip title="Number of submissions received">
            <div className="d-flex align-items-center justify-content-center ">
              <span>Submissions</span>
              <InfoIcon id={"Submissions1"}></InfoIcon>
            </div>
          </Tooltip>
        ),
        dataIndex: "submissions",
        width: 100,
        align: "center",
        render: (_: any, item: any) => {
          const { totalSubmissions = 0 } = item || {};
          console.log("totalSubmissions", totalSubmissions);
          return (
            <span>
              {totalSubmissions == null
                ? "-"
                : `${totalSubmissions} / ${TotalStudents}`}
            </span>
          );
        },
      },
      {
        title: () => (
          <Tooltip title="Number of Papers Evaluated">
            <div className="d-flex align-items-center justify-content-center ">
              <span>Evaluated</span>
              <InfoIcon id={"Submissions1"}></InfoIcon>
            </div>
          </Tooltip>
        ),
        dataIndex: "evaluated",
        width: 90,
        fixed: "left",
        align: "center",
        render: (_: any, item: any) => {
          const { totalSubmissions = 0, totalEvaluation = 0 } = item || {};
          return (
            <span>
              {totalEvaluation == null
                ? "-"
                : `${totalEvaluation} / ${totalSubmissions}`}
            </span>
          );
        },
      },
      ...(selectedType != "UPCOMING"
        ? [
            {
              title: "Evaluation Status",
              dataIndex: "evaluationStatus",
              width: 170,
              fixed: "left",
              render: (_: any, item: any) => {
                const { evaluationStatus } = item || {};
                return (
                  <Tag
                    color={EVALUATED_TEST_STATUS_COLORS[evaluationStatus]}
                    key={evaluationStatus}
                  >
                    {evaluationStatus}
                  </Tag>
                );
              },
            },
          ]
        : []),

      ...(selectedType == "PAST"
        ? [
            {
              title: "Download",
              dataIndex: "download",
              width: 10,
              render: (_: any, item: any) => {
                const medProData = testDataMap.get(item.id);
                return (
                  <Space>
                    <Button
                      type="text"
                      className="filterSpan"
                      loading={loadingMap.get(item.id) || false}
                      disabled={loadingMap.get(item.id) || false}
                      icon={
                        !medProData?.jobStatus ? (
                          <DownloadOutlined style={{ color: "#00B0F5" }} />
                        ) : (
                          <>
                            {medProData?.jobStatus === "Completed" ? (
                              <DownloadOutlined style={{ color: "#00B0F5" }} />
                            ) : (
                              <UndoOutlined style={{ color: "#00B0F5" }} />
                            )}
                          </>
                        )
                      }
                      onClick={() => handleDownload(item.id)}
                    ></Button>

                    {medProData?.jobStatus && (
                      <Tag color={COLOR_TAG[medProData.jobStatus]}>
                        {medProData?.jobStatus}
                      </Tag>
                    )}
                  </Space>
                );
              },
            },
          ]
        : []),
      {
        title: "Action",
        dataIndex: "action",
        width: 80,
        fixed: "right",
        render: (_: any, item: any) => {
          const status = item?.evaluationStatus || "";
          return (
            <div className="d-flex align-items-center justify-content-center">
              {item.format == "Objective" ? (
                "-"
              ) : (
                <Button
                  type="primary"
                  disabled={
                    selectedType == "UPCOMING" ||
                    (item?.testResultDate &&
                      moment(item.testResultDate).isBefore(moment()))
                  }
                  onClick={() => {
                    window.sessionStorage.setItem(
                      "shouldPersistMyBatchTab",
                      "true"
                    );
                    navigate("/admin/test-evaluation/" + item.id, {
                      replace: false,
                      state: {
                        test: item,
                        batchId: id,
                        testSyllabusStatus,
                        batchDetailsData: batchDetailsData,
                        batchDetail: batchDetail,
                        batchDetailById,
                        action:
                          item?.testResultDate &&
                          moment(item.testResultDate).isBefore(moment())
                            ? "view"
                            : "evaluate",
                      },
                    });
                  }}
                >
                  {["Evaluation Completed"].includes(status)
                    ? "View"
                    : "Evaluate"}
                </Button>
              )}
            </div>
          );
        },
      },
    ];
  }, [showPastTest, loadingMap, testDataMap]);
  const handleDownload = (testId: number) => {
    try {
      const newLoadingMap = new Map(loadingMap);
      newLoadingMap.set(testId, true);
      setLoadingMap(newLoadingMap);
      const obj = {
        testId: testId,
        batchId: Number(id),
      };
      PostDownloadMedPro(`${BASE_URL}${DOWNLOAD_MEDPRO_URL}`, obj, testId);
    } catch (error) {
      console.log("error", error);
    } finally {
      setTimeout(() => {
        const updatedLoadingMap = new Map(loadingMap);
        updatedLoadingMap.set(testId, false);
        setLoadingMap(updatedLoadingMap);
      }, 2000);
    }
  };

  const clearHandler = () => {
    const clearedFilter = {
      stream: null,
      segment: null,
      status: null,
      clazz: null,
      subjectList: null,
    };

    setFilterState(clearedFilter);
    const filterheadingListingArr = [...filterheadingListing].map(
      (ele: any) => {
        return { ...ele, filterSelectedData: [] };
      }
    );
    setfilterheadingListing(filterheadingListingArr);
    settestDetailsData(testDetailsMasterData);
  };
  const applyFilterHandler = () => {
    const obj: any = {};
    filterheadingListing.forEach((ele: any) => {
      obj[ele.nickName] = ele.singleSelect
        ? ele.filterSelectedData[0]
        : ele.filterSelectedData;
    });
    const filteredList = testDetailsMasterData.filter(
      (ele: any) => ele["type"] === obj["testTypes"]["label"]
    );
    settestDetailsData(filteredList);
    setFilterState(obj);
  };
  useEffect(() => {
    if (testDetailsData && testDetailsData.length > 0) {
      const url = BASE_URL + GET_TESTSYLLABUS_STATUS;
      const obj = (testDetailsData || []).map((ele: any) => {
        const newObj = {
          batchId: id,
          testScheduleId: ele.id,
        };
        testDataMap.set(ele.id, "");
        return newObj;
      });
      const filteredList = obj.filter((ele: any) => ele.testScheduleId != null);
      if (filteredList.length > 0) {
        PostTestSyllabusStatus(url, filteredList);
      }
    }
  }, [testDetailsData]);
  console.log("countscounts", counts);
  return (
    <CustomMyBatchCard screen={screen}>
      <div
        className={
          !["xs", "sm", "md"].includes(screen)
            ? "myBatchTable"
            : "myBatchTableMB"
        }
      >
        {["xs", "sm", "md"].includes(screen) &&
          !!filterheadingListing.length && (
            <FilterSliderComponent
              width={"100%"}
              isPaneOpen={globalSearchData?.isMyBatch}
              setisPaneOpen={() => {
                saveGlobalSearchData({
                  pathurl: null,
                  isStudentHealth: false,
                  isBranchHealth: false,
                  isPerformance: false,
                  isBatches: false,
                  isMyBatch: false,
                });
              }}
              hideHeader={true}
              filterheadingListing={filterheadingListing.filter((ele: any) =>
                filterListing.includes(ele.nickName)
              )}
              setfilterheadingListing={setfilterheadingListing}
              applyFilterHandler={applyFilterHandler}
              resetHandler={clearHandler}
            ></FilterSliderComponent>
          )}
        <Card className="mb-0 table-border-custom">
          <div
            className="d-flex w-100 mb-3"
            style={{ padding: "16px", gap: "16px" }}
          >
            {counts.map((ele: any, index: number) => (
              <div
                key={index}
                onClick={() => {
                  setSelectedType(ele.type);
                  setPagination((prev: any) => ({ ...prev, current: 1 }));
                }}
                style={{
                  flex: 1,
                  padding: "12px 16px",
                  borderRadius: "4px",
                  border: "1px solid #e8e8e8",
                  borderLeft:
                    selectedType === ele.type
                      ? "4px solid #1890ff"
                      : "4px solid #d9d9d9",
                  cursor: "pointer",
                  backgroundColor:
                    selectedType === ele.type ? "#f0f7ff" : "#fff",
                  transition: "all 0.3s",
                  boxShadow:
                    selectedType === ele.type
                      ? "0 2px 8px rgba(24, 144, 255, 0.15)"
                      : "none",
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    color: selectedType === ele.type ? "#1890ff" : "#8c8c8c",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    marginBottom: "4px",
                  }}
                >
                  {ele.type}
                </div>
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#262626",
                  }}
                >
                  {ele.count}
                </div>
              </div>
            ))}
          </div>
          <div className="tableFixHead">
            {!tableloading &&
            testDetailsData &&
            testDetailsData.length === 0 ? (
              <div className="mt-4 mb-8">
                <NoResultFoundSearch
                  primaryMessage="Scheduled test list not available."
                  secondaryMessage={
                    "No tests scheduled for this batch in Phoenix. Contact your EDP team for assistance."
                  }
                >
                  <NoDataFoundIcon />
                </NoResultFoundSearch>
              </div>
            ) : (
              <TableLayoutAntd isLoader={tableloading}>
                <Table
                  className="antdTablePagination"
                  scroll={{ x: "max-content" }}
                  bordered
                  size="small"
                  columns={columns}
                  dataSource={testDetailsData}
                  pagination={pagination}
                  onChange={handleTableChange}
                />
              </TableLayoutAntd>
            )}
          </div>
        </Card>
      </div>
    </CustomMyBatchCard>
  );
};

export default MyBatchTestsTab;
